import { ILanguage, MLHelper } from '@bimser/core';
import BCInputMultiLanguage, {
	IInputMultiLanguageRunTranslateProps
} from '../../../BCInputMultiLanguage';
import { IMLInputProperty, IPropertyItem } from '../../entities';
import { BCNotification, findMessage } from '../../../';

export default function MLInput(props: IMLInputProperty) {
	const replaceValue = (item: IPropertyItem, newValue: any) => {
		props.onValueChanged(item, newValue);
	};

	const onChange = (culture: string, value?: string) => {
		let newValue = { ...props.value, [culture]: value };

		if (props.item.externalData?.disableMultiLanguage) {
			culture = 'system';
		}

		if (props.item.externalData?.allowNull === false && MLHelper.isMLEmpty(newValue)) {
			BCNotification.error({
				message: findMessage.get('100652'),
				description: findMessage.get('100079').replace('$0', props.item.key)
			});

			newValue = props.value;
		}

		props.customChangeEvent
			? props.customChangeEvent(newValue)
			: replaceValue(props.item, newValue);
	};

	const getCurrentLanguage = () => {
		if (props.item.externalData?.disableMultiLanguage) {
			const systemCurrentLanguage: ILanguage = {
				id: 0,
				name: 'system',
				culture: 'system',
				isDefault: false,
				twoLetterCulture: 'system'
			};
			return systemCurrentLanguage;
		}

		return props.currentLanguage || props.item.options.currentLanguage;
	};

	return (
		<BCInputMultiLanguage
			{...(props.item.externalData && props.item.externalData.regExp
				? { regExp: props.item.externalData.regExp }
				: null)}
			key={props.item.key}
			values={props.value}
			currentLanguage={getCurrentLanguage()}
			supportedLanguages={props.supportedLanguages || props.item.options.supportedLanguages}
			onLanguageValueChange={onChange}
			disableMultiLanguage={
				props.item.externalData && props.item.externalData.disableMultiLanguage
			}
			maxLength={props.item.externalData?.maxLength}
			disabled={props.item.disabled}
			readOnly={props.readonly}
			size="small"
			translate={{
				...props.translate,
				runTranslate: (args: IInputMultiLanguageRunTranslateProps) =>
					props.translate.runTranslate({ ...args, item: props.item })
			}}
		/>
	);
}
